import { atom } from 'jotai';

const tutorialStepAtom = atom(1);
const tutorialStageAtom = atom(1);
const isTutorialActiveAtom = atom(false);

export {
  tutorialStepAtom,
  tutorialStageAtom,
  isTutorialActiveAtom,
};
